<template>
    <div class="sag-card">
        <b-card>
            <b-card-body>
                <slot></slot>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import { BCard, BCardTitle, BCardSubTitle, BCardBody, BCollapse } from 'bootstrap-vue'
export default {
    components: {
        BCard,
        BCardTitle,
        BCardSubTitle,
        BCardBody,
        BCollapse
    },
    setup(){

    }
}
</script>